import * as React from "react";
const SvgFiRrKeyboardLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M24 20a1 1 0 0 1-1 1H12c-2.757 0-5-2.243-5-5V8c0-2.757 2.243-5 5-5h11a1 1 0 0 1 0 2H12c-1.654 0-3 1.346-3 3v8c0 1.654 1.346 3 3 3h11a1 1 0 0 1 1 1m-10-8a1 1 0 0 0-1-1h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 1-1m4-1h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m5 0h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2M13 7h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m5 0h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m5 0h-1a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2m0 8h-7a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2M4.707 7.879a1 1 0 0 0-1.414 0L.586 10.586c-.78.78-.78 2.048 0 2.828l2.707 2.707a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414L2 12l2.707-2.707a1 1 0 0 0 0-1.414M11 16a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
    />
  </svg>
);
export default SvgFiRrKeyboardLeft;
